<template>
  <div 
    class="mwe-loading" 
    :class="{
      'mwe-loading-min-height': minHeight
    }"
    :style="{
      'min-height': minHeight
    }"
  >
    <div class="spinner-item">
      <div class="spinner-circle">
        <div class="circle"></div> 
      </div>
      <div class="spinner-title" v-if="_title">{{ _title }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    title: {
      type: [Boolean, String],
      default: false,
    },
    minHeight: {
      type: String,
      default: undefined,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    _title() {
      if (this.title === true) return this.$t('engine.common.loading.lblLoading', this.languageEngine);
      return this.title;
    },
  },
}
</script>

<style scope>
.mwe-loading-min-height {
  position: relative;
}
.mwe-loading-min-height .spinner-item {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
